/**
 * Splits a list into runs of at most `size`.
 *
 * Several of our endpoints cap an array in the request body, so the client has to send a
 * long list as several calls that each fit.
 *
 * `@inference.engine/utils` exports an identical function, and this is not it: that package
 * is a Nest server lib, carrying `@nestjs/common`, `openid-client` and `undici`, and is not
 * a dependency of this app. Taking it would pull server code toward the browser bundle for
 * four lines.
 */
export function chunk<T>(items: T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let start = 0; start < items.length; start += size) {
    chunks.push(items.slice(start, start + size));
  }
  return chunks;
}
